import React from 'react';
import closeImg from '../content/close.png';

export const Settings = (props) => {

    return (
        <div id="settings-panel">
            <div className="row mb-2 align-items-center">
                <div className="col">
                    <h1>{ props.locale.SETTINGS }</h1>
                </div>
                <div className="col-auto">
                    <button className="close-settings-btn" onClick={ props.closeSettings }>
                        <img src={ closeImg } />    
                    </button>                    
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="setting-box">
                        <h2>{ props.locale.SETTINGS_CHANGE_LANGUAGE }:</h2>
                        <p>{ props.locale.SETTINGS_CHANGE_LANGUAGE_DESC }</p>
                        <button
                            className="language-change-btn status-block store-status"
                            onClick={() => props.switchLanguage()}>
                            { props.locale.CHANGE_LANGUAGE }
                        </button>
                    </div>
                </div>
                <div className="col-6">
                    <div className="setting-box">
                        <h2>{ props.locale.SETTINGS_STATUS_CHANGE }:</h2>
                        {
                            props.isEnabled
                                ? <p>{ props.locale.SETTINGS_STATUS_ON_PT1 } <span className="status enabled">{ props.locale.SETTINGS_STATUS_ON_PT2 }</span> { props.locale.SETTINGS_STATUS_ON_PT3 }</p>                                
                                : <p>{ props.locale.SETTINGS_STATUS_OFF_PT1 } <span className="status disabled">{ props.locale.SETTINGS_STATUS_OFF_PT2 }</span> { props.locale.SETTINGS_STATUS_OFF_PT3 }</p>
                        }                        
                        <button
                            className="language-change-btn status-block store-status"
                            onClick={() => props.setEnabled()}>
                            { props.locale.SETTINGS_STATUS_CHANGE }
                        </button>
                    </div>
                </div>
                <div className="col-6">
                    <div className="setting-box">
                        <h2>{ props.locale.SETTINGS_TROUBLESHOOTING }:</h2>
                        <p>{ props.locale.SETTINGS_TROUBLESHOOTING_DESC }</p>
                        <button
                            className="language-change-btn status-block store-status"
                            onClick={() => props.reloadPage()}>
                            { props.locale.SETTINGS_TROUBLESHOOTING_RELOAD }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

}